import { render, staticRenderFns } from "./ResetPW.vue?vue&type=template&id=6ada40e6&"
import script from "./ResetPW.vue?vue&type=script&lang=js&"
export * from "./ResetPW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports